import { withStyles } from '@material-ui/core';
import '../DriverPopUp/HazmatPlacard/placards.css';
import StyledToolTip from '../../../../common/StyledToolTip';
import { PLACARD_CLASSES_WITH_TEXTBOX } from '../DriverPopUp/HazmatPlacard/constants';
const styles = (theme) => ({
  container: {
    paddingLeft: '16px'
  },
  placardImage: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    backgroundColor: theme.ModalBGColor,
    position: 'relative',
    zIndex: 8080
  },
  placardImageTooltip: {
    margin: -4 // used for overriding styledtooltip default padding
  },
  imageListcontainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  hazmatDetails: {
    paddingTop: 8,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: '12px',
    color: theme.ModalHeaderTextColor,
    textAlign: 'center'
  },
  hazmatUnCodes: {
    fontSize: theme.textFontSize,
    position: 'absolute',
    textAlign: 'center',
    top: '40%',
    fontWeight: 500,
    left: '30%'
  },
  iconClass: {
    paddingRight: 4,
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    display: 'flex',
    alignSelf: 'center'
  },
  tooltipPopper: {
    zIndex: 2002 //more than pickupInfo drawer zIndex
  }
});

const getHazmatClass = (placard) => {
  const classPrefix = 'bg-';
  const typePrefix = placard.bulk ? 'Bulk' : '';
  const classNumber = placard.class?.replace('.', '_') || '_'; //As of now we dont get class for pickup hazmat placards, where as for delivery we receive class from client side
  return `${classPrefix}${typePrefix}${classNumber}`;
};

const HazmatPlacard = ({ placards, classes }) => {
  return (
    <div className={classes.container}>
      <div className={classes.imageListcontainer}>
        {placards.map((placard) => {
          const hazmatClass = getHazmatClass(placard);
          const showUNCodeInTextBox = PLACARD_CLASSES_WITH_TEXTBOX.includes(hazmatClass);
          return (
            <StyledToolTip
              title={
                <div className={`${classes.placardImageTooltip} ${classes.placardImage}`}>
                  <div className={hazmatClass} />
                  <div className={classes.hazmatDetails}>
                    <div>{placard.unNumber}</div>
                  </div>
                  {showUNCodeInTextBox && <div className={classes.hazmatUnCodes}>{placard.unNumber}</div>}
                </div>
              }
              classes={{
                popper: classes.tooltipPopper
              }}>
              <i className={`icon-hazmat ${classes.iconClass}`} />
            </StyledToolTip>
          );
        })}
      </div>
    </div>
  );
};

export default withStyles(styles)(HazmatPlacard);
